(function () {
class Product {
    constructor() {
        if (Product.instance) {
            return Product.instance;
        }
        this._discountRule = [];
        this._initPrice = null;
        this._groupedTag = null;
        this._imageName = null;

        this._currentPrice = null;

        this._totalPrice = null;
        this._totalPriceElement = null;
        this._totalSavings = null;
        this._totalSavingsElement = null;
        this._initialQuantity = null;

        this._isProductOnSale = false;
        this._customImageURL = null;

        this._checkboxes = null;

        this._avpOptions = [];
        this._isusingAVP = false;
        this._AVPprice = 0;

        this._sliderQuantity = null;
        this._exponent = null;
        this._lastvalue = null;

        this._initialLoad = true;
        this._artificialLoad = false;
        this._totalItemCount = null;
        this._isTShirt = false;
        this._initalDropdownHTML = null;
        this._initalCheckboxHTML = null;
        this._initalImageUploadHTML = null;

        this._freePrint = new Map([
            ["Front", "50149571002642"],
            ["Back", "50149571035410"],
            ["Left Chest", "50149571068178"],
            ["Right Chest", "50149571100946"],
            ["Left Sleeve", "50149571133714"],
            ["Right Sleeve", "50149571166482"],
            ["Yoke", "50149571199250"],
            ["Upper Back", "50149571232018"],
        ]);

        this._Print = new Map([
            ["Front", "50150546342162"],
            ["Back", "50150546374930"],
            ["Left Chest", "50150546407698"],
            ["Right Chest", "50150546440466"],
            ["Left Sleeve", "50150546473234"],
            ["Right Sleeve", "50150546506002"],
            ["Yoke", "50150546538770"],
            ["Upper Back", "50150546571538"],
        ]);

        window.discountRule = this._discountRule;
        window.initPrice = this._initPrice;
        window.groupedTag = this._groupedTag;
        window.currentPrice = this._currentPrice;
        window.totalPrice = this._totalPrice;
        window.totalPriceElement = this._totalPriceElement;
        window.totalSavings = this._totalSavings;
        window.totalSavingsElement = this._totalSavingsElement;
        window.initialQuantity = this._initialQuantity;
        window.isProductOnSale = this._isProductOnSale;
        window.customImageURL = this._customImageURL;
        window.checkboxes = this._checkboxes;
        window.avpOptions = this._avpOptions;
        window.isusingAVP = this._isusingAVP;
        window.AVPprice = this._AVPprice;
        window.sliderQuantity = this._sliderQuantity;
        window.exponent = this._exponent;
        window.lastvalue = this._lastvalue;
        window.initialLoad = this._initialLoad;
        window.artificialLoad = this._artificialLoad;
        window.totalItemCount = this._totalItemCount;
        window.imageName = this._imageName;
        window.freePrint = this._freePrint;
        window.Print = this._Print;

        window.initalDropdownHTML = this._initalDropdownHTML;
        window.initalCheckboxHTML = this._initalCheckboxHTML;
        window.initalImageUploadHTML = this._initalImageUploadHTML;

        window.isTShirt = this._isTShirt;


        Product.instance = this;
    }

    // Getters
    get discountRule() {
        return this._discountRule;
    }
    get initPrice() {
        return this._initPrice;
    }
    get groupedTag() {
        return this._groupedTag;
    }
    get currentPrice() {
        return this._currentPrice;
    }
    get totalPrice() {
        return this._totalPrice;
    }
    get totalPriceElement() {
        return this._totalPriceElement;
    }
    get totalSavings() {
        return this._totalSavings;
    }
    get totalSavingsElement() {
        return this._totalSavingsElement;
    }
    get initialQuantity() {
        return this._initialQuantity;
    }
    get isProductOnSale() {
        return this._isProductOnSale;
    }
    get customImageURL() {
        return this._customImageURL;
    }
    get checkboxes() {
        return this._checkboxes;
    }
    get avpOptions() {
        return this._avpOptions;
    }
    get isusingAVP() {
        return this._isusingAVP;
    }
    get AVPprice() {
        return this._AVPprice;
    }
    get sliderQuantity() {
        return this._sliderQuantity;
    }
    get exponent() {
        return this._exponent;
    }
    get lastvalue() {
        return this._lastvalue;
    }
    get initialLoad() {
        return this._initialLoad;
    }
    get artificialLoad() {
        return this._artificialLoad;
    }
    get totalItemCount() {
        return this._totalItemCount;
    }
    get imageName() {
        return this._imageName;
    }
    get freePrint() {
        return this._freePrint;
    }
    get Print() {
        return this._Print;
    }

    get isTShirt() {    
        return this._isTShirt;
    }

    get initalDropdownHTML() {
        return this._initalDropdownHTML;
    }
    get initalCheckboxHTML() {
        return this._initalCheckboxHTML;
    }
    get initalImageUploadHTML() {
        return this._initalImageUploadHTML;
    }

    // Setters
    set discountRule(value) {
        this._discountRule = value;
    }
    set initPrice(value) {
        this._initPrice = value;
    }
    set groupedTag(value) {
        this._groupedTag = value;
    }
    set currentPrice(value) {
        this._currentPrice = value;
    }
    set totalPrice(value) {
        this._totalPrice = value;
    }
    set totalPriceElement(value) {
        this._totalPriceElement = value;
    }
    set totalSavings(value) {
        this._totalSavings = value;
    }
    set totalSavingsElement(value) {
        this._totalSavingsElement = value;
    }
    set initialQuantity(value) {
        this._initialQuantity = value;
    }
    set isProductOnSale(value) {
        this._isProductOnSale = value;
    }
    set customImageURL(value) {
        this._customImageURL = value;
    }
    set checkboxes(value) {
        this._checkboxes = value;
    }
    set avpOptions(value) {
        this._avpOptions = value;
    }
    set isusingAVP(value) {
        this._isusingAVP = value;
    }
    set AVPprice(value) {
        this._AVPprice = value;
    }
    set sliderQuantity(value) {
        this._sliderQuantity = value;
    }
    set exponent(value) {
        this._exponent = value;
    }
    set lastvalue(value) {
        this._lastvalue = value;
    }
    set initialLoad(value) {
        this._initialLoad = value;
    }
    set artificialLoad(value) {
        this._artificialLoad = value;
    }
    set totalItemCount(value) {
        this._totalItemCount = value;
    }
    set imageName(value) {
        this._imageName = value;
    }
    set freePrint(value) {
        this._freePrint = value;
    }
    set Print(value) {
        this._Print = value;
    }

    set isTShirt(value) {    
        this._isTShirt = value;
    }

    set initalDropdownHTML(value) {
        this._initalDropdownHTML = value;
    }
    set initalCheckboxHTML(value) {
        this._initalCheckboxHTML = value;
    }   
    set initalImageUploadHTML(value) {  
        this._initalImageUploadHTML = value; 
    }
}
window.Product = Product;
})();
new Product();
// Example usage
//const product = new Product();
//product.initPrice = 100;
//console.log(product.initPrice); // 100
